export default "__VITE_ASSET__BPrzqnTJ__"